import React from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';

import './SegmentedToggle.styles.scss';

type SegmentedToggleValue = string | number | boolean;

type SegmentedToggleOption = {
  label: React.ReactNode;
  value: SegmentedToggleValue;
};

type SegmentedToggleProps = {
  className?: string;
  options: SegmentedToggleOption[];
  selectedValue: SegmentedToggleValue;
  variant?: 'default' | 'pill';
  onChange: (value: SegmentedToggleValue) => void;
};

const SegmentedToggle: React.FC<SegmentedToggleProps> = (props) => {
  const {
    className,
    options,
    selectedValue,
    variant = 'pill',
    onChange,
  } = props;

  const classes = classNames(
    'segmented-toggle',
    `segmented-toggle--${variant}`,
    className,
  );

  return (
    <div className={classes}>
      {options.map(({ label, value }) => (
        <Button
          key={String(value)}
          className={classNames({
            selected: selectedValue === value,
          })}
          onClick={() => onChange(value)}
        >
          {label}
        </Button>
      ))}
    </div>
  );
};

export default SegmentedToggle;
